import { loadTossPayments } from "@tosspayments/tosspayments-sdk";

export interface TossPaymentRequest {
  clientKey: string;
  customerKey: string;
  orderId: string;
  orderName: string;
  amount: number;
  successUrl: string;
  failUrl: string;
  customerEmail?: string;
  customerName?: string;
  customerMobilePhone?: string;
}

export async function requestTossCardPayment(input: TossPaymentRequest) {
  if (!input.clientKey || !input.customerKey || !input.orderId || !input.orderName) throw new TypeError("Toss payment identity is required");
  if (!Number.isSafeInteger(input.amount) || input.amount < 1) throw new TypeError("Toss payment amount must be a positive KRW integer");
  const tossPayments = await loadTossPayments(input.clientKey);
  const payment = tossPayments.payment({ customerKey: input.customerKey });
  await payment.requestPayment({
    method: "CARD",
    amount: { currency: "KRW", value: input.amount },
    orderId: input.orderId,
    orderName: input.orderName,
    successUrl: input.successUrl,
    failUrl: input.failUrl,
    customerEmail: input.customerEmail,
    customerName: input.customerName,
    customerMobilePhone: input.customerMobilePhone?.replace(/\D/g, "") || undefined,
    card: { flowMode: "DEFAULT", useEscrow: false, useCardPoint: false }
  });
}
